import {bus} from '../../../utils/bus'
import _flatten from 'lodash/flatten'
import {getPermissionImmediately} from '../../../utils/storage'
import _once from 'lodash/once'
import {ROUTE_NAME_OF_DI_PAGE} from './index'

const navConfigs = []

export const _registerNav = (navConfig) => {
  navConfigs.push(navConfig)
}

export const _schoolNameMixIn = configArray => {
  configArray.forEach(({to, sub}) => {
    if (to) {
      if (!to.params) {
        to.params = {}
      }
    }
    if (sub) {
      _schoolNameMixIn(sub)
    }
  })
  return configArray
}

export const _permissionFilter = _once(() => {
  return navConfigs.map(nav => {
    // const p = getPermissionImmediately()
    // const permission = _flatten(p.map(it => it.split(',')))
    const filter = (nav) => {
      return nav.filter(it => {
        // if (!it.permissionCode) {
        //   return true
        // }
        // if (it.sub) {
        //   it.sub = filter(it.sub)
        // }
        // return permission.includes(it.permissionCode)
        return true
      })
    }
    return filter(nav)
  })
})

export const _getFirstNavItem = () => {
  const _getFirst = (nav) => {
    if (nav[0].to) {
      return nav[0]
    }
    return _getFirst(nav[0].sub)
  }
  return _getFirst(bus.global.currentNavConfig)
}

export function onBreadcrumbClick () {
  const to = _getFirstNavItem().to
  if (to.diName) {
    this.routerPush(ROUTE_NAME_OF_DI_PAGE.CENTER, {diName: to.diName})
  } else {
    this.routerPush(to.routeName)
  }
}

export default navConfigs



// WEBPACK FOOTER //
// ./src/components/common/di-ding/_nav-maps.js